import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
export function Hero() {
  return <section id="top" className="relative bg-texture-dark text-cream pt-32 lg:pt-44 pb-32 lg:pb-40 overflow-hidden" data-id="element-89">
      <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 left-8 flex-col items-center gap-6 text-[9px] tracking-[0.5em] uppercase text-cream/35" data-id="element-90">
        <span style={{
        writingMode: 'vertical-rl'
      }} className="rotate-180" data-id="element-91">
          Signature Basque Cheesecake
        </span>
        <span className="w-px h-16 bg-cream/15" data-id="element-92" />
      </div>
      <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 right-8 flex-col items-center gap-6 text-[9px] tracking-[0.5em] uppercase text-cream/35" data-id="element-93">
        <span className="w-px h-16 bg-cream/15" data-id="element-94" />
        <span style={{
        writingMode: 'vertical-rl'
      }} data-id="element-95">
          Magnolia · Texas · MMXXVI
        </span>
      </div>

      <div className="max-w-[1300px] mx-auto px-8 lg:px-20" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9
      }} className="flex items-center justify-center gap-4 text-[10px] tracking-[0.5em] uppercase text-cream/45 mb-12 lg:mb-16" data-id="element-97">
          <span className="w-12 h-px bg-cream/25" data-id="element-98" />
          <span className="font-serif italic text-caramel normal-case tracking-[0.15em] text-[13px]" data-id="element-99">
            an invitation
          </span>
          <span className="w-12 h-px bg-cream/25" data-id="element-100" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.1
      }} className="font-serif text-center text-cream font-light leading-[0.88] tracking-[-0.035em]" style={{
        fontSize: 'clamp(64px, 13vw, 200px)'
      }} data-id="element-101">
          One Bite
          <br data-id="element-102" />
          <span className="italic font-extralight" data-id="element-103">Closer</span>
          <br data-id="element-104" />
          to Heaven<span className="text-caramel" data-id="element-105">.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.4
      }} className="mt-20 lg:mt-28 mx-auto max-w-[640px]" data-id="element-106">
          <div className="text-center mb-6 flex items-center justify-center gap-4 text-[10px] tracking-[0.4em] uppercase text-cream/40" data-id="element-107">
            <span data-id="element-108">Plate Nº 001</span>
            <span className="w-1 h-1 rounded-full bg-caramel" data-id="element-109" />
            <span data-id="element-110">Signature</span>
          </div>
          <div className="relative" data-id="element-111">
            <div className="absolute -inset-3 border border-cream/15" aria-hidden data-id="element-112" />
            <div className="relative aspect-[4/5] overflow-hidden bg-espresso" data-id="element-113">
              <img src={IMAGES.cheesecake} alt="TARTA signature Basque cheesecake — caramelized top, custard center" className="w-full h-full object-cover" data-id="element-114" />
            </div>
          </div>
          <div className="mt-8 text-center max-w-md mx-auto" data-id="element-115">
            <p className="font-serif italic text-cream/70 text-lg lg:text-xl leading-[1.5]" data-id="element-116">
              "A deeply caramelized crown. A custard-soft center. A finish that
              lingers, beautifully."
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.9
      }} className="mt-20 lg:mt-28 flex flex-col items-center gap-8" data-id="element-117">
          <a href="#waitlist" className="group inline-flex items-center gap-6 text-[11px] tracking-[0.4em] uppercase text-cream" data-id="element-118">
            <span className="w-10 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-16 transition-all duration-500" data-id="element-119" />
            <span className="relative font-serif italic text-[15px] tracking-[0.05em] normal-case" data-id="element-120">
              Reserve your first slice
            </span>
            <span className="w-10 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-16 transition-all duration-500" data-id="element-121" />
          </a>
          <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="text-[10px] tracking-[0.4em] uppercase text-cream/45 hover:text-caramel transition-colors duration-500" data-id="element-122">
            Follow @tartahtx
          </a>
        </motion.div>
      </div>
    </section>;
}